import { render, staticRenderFns } from "./OrderStatusBanner.vue?vue&type=template&id=38016876&scoped=true&"
import script from "./OrderStatusBanner.vue?vue&type=script&lang=js&"
export * from "./OrderStatusBanner.vue?vue&type=script&lang=js&"
import style0 from "./OrderStatusBanner.vue?vue&type=style&index=0&id=38016876&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38016876",
  null
  
)

export default component.exports